import { axiosInstance } from 'network/apis';

export const getAllProjectManagers = async (payload) => {
  return await axiosInstance.get(`/project_manager/client/${payload.clientId}`, { handlerEnabled: true })
};

export default {
    getAllProjectManagers,
}